import type { BlocksAutoRatesConfigProductComponentProduct } from '@twisto/api-cms/generated-types'

export type AutoRatesData =
  | Partial<
      Record<
        NonNullable<BlocksAutoRatesConfigProductComponentProduct>,
        Record<string, string>
      >
    >
  | undefined

export const getConfigURLPath = (
  product: BlocksAutoRatesConfigProductComponentProduct
): string => {
  switch (product) {
    case 'installments-config':
      return 'installments/config'
    case 'deferred-payment-config':
      return 'deferred-payment/config'
    default:
      return ''
  }
}

export const getExampleURLSegment = (
  product: BlocksAutoRatesConfigProductComponentProduct
): string => {
  switch (product) {
    case 'deferred-payment-example':
      return 'deferred-payment'
    case 'installments-example':
      return 'installments'
    case 'divided-payments-example':
      return 'divided-payments'
    default:
      return ''
  }
}
